import React from 'react';
// @ts-ignore
import { Button, Heading, HorizontalRule, Loader, Link } from 'arag-ui-lib';
import PolicyHolderReviewClaimOverview from '../policyHolderReviewClaimOverview/policyHolderReviewClaimOverview';
import PolicyHolderReviewClaimQuestionsAnswers from '../policyHolderReviewClaimQuestionsAnswers/policyHolderReviewClaimQuestionsAnswers';
import styles from './policyHolderClaimDetails.module.scss';
import moment from 'moment';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';
import { useTranslation } from 'react-i18next';
type ClaimReviewOverviewObject = {
    formattedType: string;
    claimReference: string;
    createdDate: moment.MomentInput | any;
};
type Props = {
    submitting: boolean;
    claimReviewOverview: ClaimReviewOverviewObject | null;
    claimReviewAnswersGroupedByStep: Array<any> | null;
    acceptClaimReview: () => void;
    getRejectionFormClaimReview: () => void;
    rejectFormLoading: boolean;
};

const PolicyHolderClaimDetails = (props: Props): JSX.Element => {
    const {
        submitting,
        claimReviewOverview,
        claimReviewAnswersGroupedByStep,
        acceptClaimReview,
        getRejectionFormClaimReview,
        rejectFormLoading,
    } = props;
    const { t } = useTranslation();
    return (
        <div id={'claim_review_details_wrapper'}>
            <div id="claim_review_print_content">
                <Heading variant="h2" title={t('completedClaimForm')} />
                {!GENERAL_FUNCTIONS.isAndroidDevice() && (
                    <div className={styles['print-button']}>
                        <Link
                            variant="print"
                            label={t('print')}
                            onClick={() => window.print()}
                        />
                    </div>
                )}
                <PolicyHolderReviewClaimOverview
                    claimReviewOverview={claimReviewOverview}
                />
                <HorizontalRule />
                <PolicyHolderReviewClaimQuestionsAnswers
                    questionsWithAnswersGroupedByStep={
                        claimReviewAnswersGroupedByStep
                    }
                />
            </div>
            <div>
                <div className={'row col-sm-12'}>
                    <div
                        className={'col-sm-2 col-sm-offset-9'}
                        style={{ marginBottom: '10px' }}
                    >
                        <Button
                            variant="quaternary"
                            label={t('reject')}
                            arrowDirection="left"
                            onClick={getRejectionFormClaimReview}
                        />
                    </div>
                    <div className={'col-sm-1'}>
                        <Button
                            variant="primary"
                            label={t('claimReviewAccept')}
                            arrowDirection="left"
                            onClick={acceptClaimReview}
                        />
                    </div>
                </div>
                <div className={'form-group row'}>
                    <div className={'col-sm-12'}>
                        <div className={'col-sm-offset-9'}>
                            {submitting && (
                                <Loader
                                    id={'rejected_claim_review_loader'}
                                    variant="inline"
                                    label={t('submitting')}
                                />
                            )}
                        </div>
                    </div>
                    <div className={'col-sm-12'}>
                        <div className={'col-sm-offset-9'}>
                            {rejectFormLoading && (
                                <Loader
                                    id={'rejected_claim_review_loader'}
                                    variant="inline"
                                    label={t('loading')}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PolicyHolderClaimDetails;
